import type { ComboVariation, Proposta } from '@/types'
import type { ComboData } from './types'

export function toDateInputValue(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function addDaysToDateInput(base: Date, days: number): string {
  const next = new Date(base)
  next.setDate(next.getDate() + days)
  return toDateInputValue(next)
}

export function defaultValidadeDate(daysFromNow = 7): string {
  return addDaysToDateInput(new Date(), daysFromNow)
}

export function maxValidadeDateInput(daysFromNow = 90): string {
  return addDaysToDateInput(new Date(), daysFromNow)
}

export function validadeDaysFromDate(validadeAte: string, from: Date = new Date()): number {
  const [year, month, day] = validadeAte.split('-').map(Number)
  if (!year || !month || !day) return 7

  const end = new Date(year, month - 1, day, 12, 0, 0, 0)
  const start = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 12, 0, 0, 0)
  const diff = Math.round((end.getTime() - start.getTime()) / 86_400_000)
  return Math.max(1, Math.min(90, diff || 1))
}

export function validadeDateFromProposal(
  proposta: Pick<Proposta, 'validUntil' | 'validade' | 'createdAt'>,
): string {
  if (proposta.validUntil) {
    return toDateInputValue(new Date(proposta.validUntil))
  }
  const base = proposta.createdAt ? new Date(proposta.createdAt) : new Date()
  return addDaysToDateInput(base, proposta.validade || 7)
}

export function parseComboVariationsForEdit(proposta: Proposta): ComboVariation[] {
  const ext = proposta as Proposta & { comboVariations?: ComboVariation[] }
  if (Array.isArray(ext.comboVariations) && ext.comboVariations.length > 0) {
    return ext.comboVariations
  }
  try {
    const dados = (proposta as { dados?: string }).dados
    if (!dados) return []
    const parsed = JSON.parse(dados) as { comboVariations?: ComboVariation[] }
    return Array.isArray(parsed.comboVariations) ? parsed.comboVariations : []
  } catch {
    return []
  }
}

export function parseCombosForEdit(proposta: Proposta): ComboData[] {
  if (!Array.isArray(proposta.combos) || proposta.combos.length === 0) return []
  return proposta.combos.map((c, i) => ({
    id: c.id ?? `combo-${i}`,
    nome: c.nome ?? `Combo ${i + 1}`,
    desconto: c.desconto ?? 0,
    itemIds: c.itemIds ?? [],
  }))
}
